import { useEffect } from "react";

const GptAd = ({ id }) => {
  useEffect(() => {
    if (!window.googletag) return;

    window.googletag.cmd.push(() => {
      window.googletag.display(id);
    });
  }, [id]);

  return <div id={id}></div>;
};

export default GptAd;